// src/pages/MetaForm.js
import React, { useState, useEffect } from 'react';
import {
  Container, Paper, Typography, TextField, Button, Box,
  FormControlLabel, Checkbox, Alert
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api/axiosConfig';

const MetaForm = () => {
  const { idPoa, idMeta } = useParams();
  const navigate = useNavigate();
  const usuarioActual = localStorage.getItem('user');

  const [formData, setFormData] = useState({
    id_poa_proyecto: parseInt(idPoa, 10),
    volumen_trabajo: '',
    unidad_medida: '',
    trimestre1: 0,
    trimestre2: 0,
    trimestre3: 0,
    trimestre4: 0,
    anno: new Date().getFullYear(),
    activo: true,
    observaciones: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Cargar datos si es edición
  useEffect(() => {
    if (idMeta) {
      const fetchMeta = async () => {
        setLoading(true);
        try {
          const res = await api.get(`/metas/${idMeta}/`);
          setFormData(res.data);
        } catch (err) {
          setError('Error al cargar la meta');
          console.error(err);
        } finally {
          setLoading(false);
        }
      };
      fetchMeta();
    }
  }, [idMeta]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const payload = {
      ...formData,
      creado_por: usuarioActual,
      modificado_por: usuarioActual,
    };

    try {
      if (idMeta) {
        await api.put(`/metas/${idMeta}/`, {
          ...formData,
          modificado_por: usuarioActual,
        });
      } else {
        await api.post('/metas/', payload);
      }
      navigate(`/poa/${idPoa}/metas`);
    } catch (err) {
      console.error('Error al guardar meta:', err.response || err);
      setError(err.response?.data?.detail || 'Error al guardar. Verifica los datos.');
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h5" gutterBottom>
          {idMeta ? 'Editar Meta' : 'Nueva Meta'}
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            label="Volumen de Trabajo *"
            fullWidth
            value={formData.volumen_trabajo}
            onChange={(e) => setFormData({ ...formData, volumen_trabajo: e.target.value })}
            margin="normal"
            required
          />

          <TextField
            label="Unidad de Medida *"
            fullWidth
            value={formData.unidad_medida}
            onChange={(e) => setFormData({ ...formData, unidad_medida: e.target.value })}
            margin="normal"
            required
          />

          <TextField
            label="Trimestre 1"
            type="number"
            fullWidth
            value={formData.trimestre1}
            onChange={(e) => setFormData({ ...formData, trimestre1: Number(e.target.value) || 0 })}
            margin="normal"
          />

          <TextField
            label="Trimestre 2"
            type="number"
            fullWidth
            value={formData.trimestre2}
            onChange={(e) => setFormData({ ...formData, trimestre2: Number(e.target.value) || 0 })}
            margin="normal"
          />

          <TextField
            label="Trimestre 3"
            type="number"
            fullWidth
            value={formData.trimestre3}
            onChange={(e) => setFormData({ ...formData, trimestre3: Number(e.target.value) || 0 })}
            margin="normal"
          />

          <TextField
            label="Trimestre 4"
            type="number"
            fullWidth
            value={formData.trimestre4}
            onChange={(e) => setFormData({ ...formData, trimestre4: Number(e.target.value) || 0 })}
            margin="normal"
          />

          <TextField
            label="Año *"
            type="number"
            fullWidth
            value={formData.anno}
            onChange={(e) => setFormData({ ...formData, anno: Number(e.target.value) })}
            margin="normal"
            required
          />

          <TextField
            label="Observaciones"
            multiline
            rows={3}
            fullWidth
            value={formData.observaciones}
            onChange={(e) => setFormData({ ...formData, observaciones: e.target.value })}
            margin="normal"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={formData.activo}
                onChange={(e) => setFormData({ ...formData, activo: e.target.checked })}
              />
            }
            label="Activo"
          />

          <Box sx={{ mt: 2 }}>
            <Button
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{ mr: 1 }}
            >
              {loading ? 'Guardando...' : idMeta ? 'Actualizar' : 'Guardar'}
            </Button>
            <Button onClick={() => navigate(`/poa/${idPoa}/metas`)}>
              Cancelar
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default MetaForm;